import React from 'react';
import RadioSelect from './RadioSelect';
import DropdownSelect from './DropdownSelect';
import MultiSelect from './MultiSelect';
import DateInput from '../Section/DateInput';

const SelectField = ({
  option,
  onMultiSelectChange,
  onSelectChange,
  onDateChange
}) => {
  const { name, type, id, values, selectValue } = option;
  const defaultProps = {
    id,
    label: name,
    choices: values,
    selectValue
  };

  if (type === 'multi_select') {
    return (
      <MultiSelect
        onMultiSelectChange={onMultiSelectChange}
        {...defaultProps}
      />
    );
  }

  if (type === 'date') {
    return (
      <DateInput
        type={type}
        onDateChange={onDateChange}
        {...defaultProps}
        value={selectValue}
      />
    );
  }

  if (values.length > 2)
    return <DropdownSelect onSelectChange={onSelectChange} {...defaultProps} />;

  return <RadioSelect onSelectChange={onSelectChange} {...defaultProps} />;
};

export default SelectField;



// WEBPACK FOOTER //
// ./src/component/TaskCreator/PreSection/SelectField.js